import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { SafeDateTimePicker } from "components/SafeDateTimePicker";
import { useTenantData } from "contexts/tenant";
import { useTenantTranslation } from "hooks/formatters";

dayjs.extend(utc);
dayjs.extend(timezone);

export const SearchEffectiveTimestamp = ({
  timestamp,
  onChange,
  disabled,
}: {
  timestamp: string | null;
  onChange: (timestamp: string | null) => void;
  disabled: boolean;
}) => {
  const { t } = useTenantTranslation();
  const { local_timezone: localTimezone } = useTenantData();
  const [selectedTimestamp, setSelectedTimestamp] = useState(() =>
    timestamp === null ? null : dayjs(timestamp)
  );
  return (
    <SafeDateTimePicker
      label={`${t("autoEffectiveTimestamp")} (${localTimezone})`}
      timezone={localTimezone}
      value={selectedTimestamp}
      disabled={disabled}
      onChange={(selected) => {
        setSelectedTimestamp(selected);
        onChange(selected?.toISOString() ?? null);
      }}
      onInvalidDate={() => {
        onChange(null);
      }}
      slotProps={{
        textField: { fullWidth: true, error: timestamp === null },
      }}
    />
  );
};
